// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".label[data-v-f504a4dc] {\n  font-weight: normal;\n  font-size: 0.875rem;\n  color: #727272;\n}\n.info[data-v-f504a4dc] {\n  font-weight: normal;\n  color: #11291B;\n}", ""]);
// Exports
module.exports = exports;
